import * as React from 'react';
import classnames from 'classnames';
import { App } from '@capacitor/app';

import { useApplication } from '../AppContext';

export const PageTitle = React.memo(({ children, className, shouldShowVolume = false, returnPage = undefined, game = null }) => {

	const app = useApplication();
	const userdata = app.userdata;
	const [isMuted, setIsMuted] = React.useState(userdata?.isMuted);

	const handleVolumeClick = React.useCallback((e) => {
		e?.stopPropagation?.();
		e?.preventDefault?.();

		const isMuted = !userdata?.isMuted;
		app.setIsMuted(isMuted);

		setIsMuted(isMuted);

		// Control game audio			
		if (game?.setAudioEnabled) {
			game.setAudioEnabled(!isMuted);
		}
	}, [app, game, userdata?.isMuted]);

	const handleBackClick = React.useCallback((e) => {
		e?.stopPropagation?.();
		e?.preventDefault?.();
		app.multiplayer.leaveGameRooms();
		app.navigate(returnPage ?? '#');
	}, [app, returnPage]);

	React.useEffect(() => {
		const listener = () => {
			handleBackClick();
		};

		let removeHandler;

		App.addListener('backButton', listener).then((handle) => {
			removeHandler = handle.remove;
		});

		return () => {
			if (typeof removeHandler === 'function') {
				removeHandler();
			} else {
				App.removeAllListeners();
			}
		};
	}, [handleBackClick]);

	const volumeControl = React.useMemo(() => {
		if (!shouldShowVolume) {
			return null;
		}

		return (
			<a
				className={classnames('volumeButton', 'ui-icon', isMuted ? 'ui-volume-off' : 'ui-volume-on')}
				href="#/"
				onClick={handleVolumeClick}
				id="menu-volume-button">
			</a>
		);
	}, [shouldShowVolume, isMuted, handleVolumeClick]);

	return (
		<div className={classnames('pageTitle', 'flex-0-1-auto', className)}>
			<a className="ui-icon ui-back backButton" href="#" onClick={handleBackClick}></a>
			{volumeControl}
			{children}
		</div>
	);
});

PageTitle.displayName = 'PageTitle';
